(ns iris.logs.views.breadcrumbs)

(defn breadcrumbs [items]
  [:nav
   {:aria-label "breadcrumb"}
   [:ol
    {:class "breadcrumb"}
    [:li
     {:class "breadcrumb-item"}
     [:a {:href "/logs"} "Logs"]]
    (for [[idx item] (map-indexed vector items)]
      [:li
       {:key   idx
        :class (str "breadcrumb-item" (when (= idx (dec (count items))) " active"))
        :aria-current (when (= idx (dec (count items))) "page")}
       item])]])

;; (defn breadcrumbs []
;;   [:nav
;;    {:class (css :flex :bg-gray-100 :rounded-md :p-2 :text-lg) :aria-label "Breadcrumb"}
;;    [:ol
;;     {:class (css :inline-flex :items-center :space-x-1 :md:space-x-2)}
;;     [:li
;;      {:class (css :inline-flex :items-center)}
;;      [:a
;;       {:href "/logs"
;;        :class
;;        (css :inline-flex :items-center :font-medium :text-sky-600 [:hover :text-sky-700])}
;;       [:svg
;;        {:class (css :w-4 :h-4 :me-2.5 :mx-2)
;;         :aria-hidden "true"
;;         :xmlns "http://www.w3.org/2000/svg"
;;         :fill "currentColor"
;;         :viewBox "0 0 20 20"}
;;        [:path
;;         {:d
;;          "m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"}]]
;;       "Logs"]]
;;     [:li
;;      [:div
;;       {:class (css :flex :items-center)}
;;       [:svg
;;        {:class (css :w-3 :h-3 :text-gray-400 :mx-1)
;;         :aria-hidden "true"
;;         :xmlns "http://www.w3.org/2000/svg"
;;         :fill "none"
;;         :viewBox "0 0 6 10"}
;;        [:path
;;         {:stroke "currentColor"
;;          :stroke-linecap "round"
;;          :stroke-linejoin "round"
;;          :stroke-width "2"
;;          :d "m1 9 4-4-4-4"}]]
;;       [:a
;;        {:href "/aaalphabet.TLO"
;;         :class
;;         (css :ms-1 :font-medium :text-sky-600 :md:ms-2 [:hover :text-sky-700])}
;;        "/aaalphabet.TLO"]]]
;;     [:li
;;      [:div
;;       {:class (css :flex :items-center)}
;;       [:svg
;;        {:class (css :w-3 :h-3 :text-gray-400 :mx-1)
;;         :aria-hidden "true"
;;         :xmlns "http://www.w3.org/2000/svg"
;;         :fill "none"
;;         :viewBox "0 0 6 10"}
;;        [:path
;;         {:stroke "currentColor"
;;          :stroke-linecap "round"
;;          :stroke-linejoin "round"
;;          :stroke-width "2"
;;          :d "m1 9 4-4-4-4"}]]
;;       [:a
;;        {:href "/t/1jkd7mhqj"
;;         :class
;;         (css :ms-1 :font-medium :text-sky-600 :md:ms-2 [:hover :text-sky-700])}
;;        "+1jkd7mhqj"]]]
;;     [:li
;;      {:aria-current "page"}
;;      [:div
;;       {:class (css :flex :items-center)}
;;       [:svg
;;        {:class (css :w-3 :h-3 :text-gray-400 :mx-1)
;;         :aria-hidden "true"
;;         :xmlns "http://www.w3.org/2000/svg"
;;         :fill "none"
;;         :viewBox "0 0 6 10"}
;;        [:path
;;         {:stroke "currentColor"
;;          :stroke-linecap "round"
;;          :stroke-linejoin "round"
;;          :stroke-width "2"
;;          :d "m1 9 4-4-4-4"}]]
;;       [:span
;;        {:class (css :ms-1 :font-medium :text-gray-500 :md:ms-2)}
;;        "@ce"]]]]]
;;   )
